import { type JanusCtx, type Row, ecId, ecLean, insertRoll, refuse, upper } from './context.js';
import type { JanusInput } from './janus.js';
import { abilityRangeAllows } from './range-check.js';
import { opposingTeams } from '../reactions/php-row-rules.js';

/** Readying reserves a watch, not a cast: RX spends reaction/mana only when it fires. */
export function armCounterspell(ctx: JanusCtx, input: JanusInput, ability: Row, caster: Row, targets: Row[]): void {
  const flag = ctx.read.value(ability, 'counterspelling_effect');
  if (flag == null || flag === '' || flag === 0 || flag === '0' || flag === false)
    refuse('This ability is not flagged as a counterspelling effect.');
  if (targets.length !== 1 || !ecId(targets[0]!)) refuse('Counterspell must be readied against exactly one creature.');
  const target = targets[0]!;
  if (ecId(target) === ecId(caster)) refuse('You cannot ready counterspell against yourself.');
  if (!opposingTeams(caster, target, (row, key) => ctx.read.value(row, key)))
    refuse('Counterspell can only be readied against a creature on the opposing side.');
  if (!abilityRangeAllows(ctx, caster, target, ability, 'arm_counterspell:range', false))
    refuse('Counterspell target is out of range.');
  if (ctx.read.inCombat(ctx.encounter, caster) && Number(ecLean(caster, 'reaction')) !== 1)
    refuse('You need an available reaction to ready Counterspell.');
  ctx.counterspellArm = { kind: 'counterspell', triggerId: upper(ctx.read.uuid()), targetId: ecId(target),
    itemId: upper(input.abilityId), mode: 'arm_counterspell' };
  insertRoll(ctx, { roll_type_1: 'counterspell_armed', roll_item_id: input.abilityId, by: caster, to: target });
}
